import {
  EVENT_SET_PROFILE,
  Profile,
} from '@weblite/sahab-profile-action/profile'
import { serverSub } from '$func/subscription'
import { profileStorage } from './storage'

serverSub.subscribe(EVENT_SET_PROFILE, (profile: Partial<Profile>) =>
  profileStorage.set(profile),
)
